import React from 'react';
import { LegalPage } from '../components/LegalPage';
import { privacyPolicy } from '../data/legal';
export function PrivacyPolicyPage() {
  return <LegalPage document={privacyPolicy} data-id="element-223" data-mp="31qjq8o1mo3xw" />;
}